module.exports = __webpack_public_path__ + "static/img/img-main-features-setcion-1.df9fe33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/img-main-features-setcion-1.png
// module id = TSWc
// module chunks = 18